export const OCCASIONS = {
  mariage: {
    path: "/musique-mariage",
    fr: {
      metaTitle: "Chanson de Mariage Personnalisée par IA | Kalypso Music",
      metaDescription: "Créez une chanson de mariage unique avec vos prénoms et votre histoire d'amour. Paroles, voix chantée et pochette générées par intelligence artificielle en quelques minutes. Le cadeau de mariage le plus original.",
      heroTitle: "La chanson de mariage qui racontera votre histoire",
      heroSubtitle: "Offrez à votre partenaire, à vos témoins ou à vos parents une chanson 100% personnalisée pour le plus beau jour de votre vie. Vos prénoms, votre histoire, votre style musical préféré.",
    },
    en: {
      metaTitle: "Personalized AI Wedding Song | Kalypso Music",
      metaDescription: "Create a unique wedding song with your names and your love story. Lyrics, sung vocals and cover art generated by AI in minutes. The most original wedding gift.",
      heroTitle: "The wedding song that will tell your story",
      heroSubtitle: "Gift your partner, your witnesses or your parents a fully personalized song for the most beautiful day of your life. Your names, your story, your favorite musical style.",
    },
  },
  anniversaire: {
    path: "/musique-anniversaire",
    fr: {
      metaTitle: "Chanson d'Anniversaire Personnalisée par IA | Kalypso Music",
      metaDescription: "Surprenez un proche avec une chanson d'anniversaire unique créée par IA : ses prénoms, son histoire, son style préféré. Bien plus original qu'un simple cadeau. Prête en quelques minutes.",
      heroTitle: "Une chanson d'anniversaire qu'on n'oublie jamais",
      heroSubtitle: "Remplacez le cadeau classique par une chanson unique, écrite et composée par intelligence artificielle spécialement pour la personne que vous aimez.",
    },
    en: {
      metaTitle: "Personalized AI Birthday Song | Kalypso Music",
      metaDescription: "Surprise a loved one with a unique AI-generated birthday song: their name, their story, their favorite style. Much more original than a regular gift. Ready in minutes.",
      heroTitle: "A birthday song they'll never forget",
      heroSubtitle: "Replace the classic gift with a unique song, written and composed by artificial intelligence especially for the person you love.",
    },
  },
  naissance: {
    path: "/musique-naissance",
    fr: {
      metaTitle: "Berceuse & Chanson de Naissance Personnalisée par IA",
      metaDescription: "Célébrez l'arrivée de votre enfant avec une berceuse ou une chanson de naissance unique, composée par IA avec son prénom et votre message. Un souvenir précieux pour toute la vie.",
      heroTitle: "Une berceuse rien que pour lui, rien que pour elle",
      heroSubtitle: "Célébrez la naissance de votre enfant avec une chanson douce et personnalisée, à écouter et réécouter pendant des années.",
    },
    en: {
      metaTitle: "Personalized AI Lullaby & Birth Song",
      metaDescription: "Celebrate your child's arrival with a unique AI-composed lullaby or birth song featuring their name and your message. A precious memory for life.",
      heroTitle: "A lullaby just for them",
      heroSubtitle: "Celebrate your child's birth with a soft, personalized song to listen to again and again for years to come.",
    },
  },
  cadeau: {
    path: "/idee-cadeau-original",
    fr: {
      metaTitle: "Idée Cadeau Original : une Chanson Personnalisée par IA",
      metaDescription: "En manque d'inspiration ? Offrez une chanson personnalisée créée par intelligence artificielle : le cadeau le plus original et le plus émouvant pour toutes les occasions.",
      heroTitle: "L'idée cadeau la plus originale que vous trouverez",
      heroSubtitle: "Fatigué des cadeaux classiques ? Offrez une chanson unique, écrite pour la personne que vous aimez, livrable en quelques minutes avec certificat cadeau imprimable.",
    },
    en: {
      metaTitle: "Original Gift Idea: a Personalized AI Song",
      metaDescription: "Out of ideas? Gift a personalized song created by artificial intelligence: the most original and moving gift for any occasion.",
      heroTitle: "The most original gift idea you'll find",
      heroSubtitle: "Tired of classic gifts? Gift a unique song, written for the person you love, delivered in minutes with a printable gift certificate.",
    },
  },
  enterrement: {
    path: "/chanson-enterrement-hommage",
    fr: {
      metaTitle: "Chanson d'Hommage pour Enterrement Personnalisée par IA",
      metaDescription: "Rendez un dernier hommage unique à un être cher avec une chanson personnalisée créée par IA : son prénom, ses souvenirs, une mélodie douce pour honorer sa mémoire lors des funérailles ou d'une cérémonie commémorative.",
      heroTitle: "Une chanson d'hommage pour honorer sa mémoire",
      heroSubtitle: "Créez une chanson douce et personnalisée pour rendre hommage à un être cher lors d'un enterrement, d'une cérémonie commémorative ou d'un anniversaire de décès. Un souvenir musical unique et apaisant.",
    },
    en: {
      metaTitle: "Personalized AI Funeral Tribute Song",
      metaDescription: "Pay a unique final tribute to a loved one with a personalized AI-created song: their name, their memories, a gentle melody to honor their memory at a funeral or memorial service.",
      heroTitle: "A tribute song to honor their memory",
      heroSubtitle: "Create a gentle, personalized song to honor a loved one at a funeral, memorial service, or anniversary of their passing. A unique and soothing musical keepsake.",
    },
  },
  retraite: {
    path: "/chanson-depart-retraite",
    fr: {
      metaTitle: "Chanson pour Départ à la Retraite Personnalisée par IA",
      metaDescription: "Célébrez le départ à la retraite d'un collègue ou d'un proche avec une chanson personnalisée et pleine d'humour ou d'émotion, créée par IA en quelques minutes. L'idée cadeau collègue la plus originale.",
      heroTitle: "La chanson parfaite pour un départ à la retraite",
      heroSubtitle: "Marquez ce grand moment avec une chanson unique, drôle ou émouvante, qui résume sa carrière et ses plus beaux souvenirs. Le cadeau collectif idéal entre collègues.",
    },
    en: {
      metaTitle: "Personalized AI Retirement Song",
      metaDescription: "Celebrate a colleague's or loved one's retirement with a personalized, funny or moving song, created by AI in minutes. The most original coworker gift idea.",
      heroTitle: "The perfect song for a retirement send-off",
      heroSubtitle: "Mark this big moment with a unique song, funny or touching, that sums up their career and best memories. The ideal group gift among colleagues.",
    },
  },
  fiancailles: {
    path: "/chanson-fiancailles",
    fr: {
      metaTitle: "Chanson de Fiançailles Personnalisée par IA | Kalypso Music",
      metaDescription: "Célébrez vos fiançailles avec une chanson unique qui raconte le début de votre plus belle histoire. Paroles et voix chantée personnalisées, générées par IA en quelques minutes.",
      heroTitle: "La chanson qui célèbre le début de votre histoire",
      heroSubtitle: "Immortalisez votre demande en mariage ou vos fiançailles avec une chanson 100% personnalisée, à écouter ensemble ou à partager avec vos proches.",
    },
    en: {
      metaTitle: "Personalized AI Engagement Song | Kalypso Music",
      metaDescription: "Celebrate your engagement with a unique song that tells the story of your love. Personalized lyrics and sung vocals, generated by AI in minutes.",
      heroTitle: "The song that celebrates the start of your story",
      heroSubtitle: "Immortalize your proposal or engagement with a fully personalized song, to listen to together or share with loved ones.",
    },
  },
  evjf_evg: {
    path: "/chanson-evjf-evg",
    fr: {
      metaTitle: "Chanson EVJF / EVG Personnalisée et Drôle par IA",
      metaDescription: "Créez la chanson la plus drôle et personnalisée pour l'enterrement de vie de jeune fille ou de garçon de votre ami(e) : anecdotes, prénoms, private jokes - le clou de la soirée garanti.",
      heroTitle: "La chanson qui va marquer son EVJF ou son EVG",
      heroSubtitle: "Surprenez la future mariée ou le futur marié avec une chanson personnalisée, pleine d'anecdotes et d'humour, créée en quelques minutes pour l'ambiance de la soirée.",
    },
    en: {
      metaTitle: "Funny Personalized AI Bachelorette/Bachelor Party Song",
      metaDescription: "Create the funniest, most personalized song for your friend's bachelorette or bachelor party: inside jokes, names, memories - guaranteed highlight of the night.",
      heroTitle: "The song that will make their party unforgettable",
      heroSubtitle: "Surprise the bride or groom-to-be with a personalized, funny song full of inside jokes, created in minutes to set the mood for the night.",
    },
  },
  diplome: {
    path: "/chanson-remise-diplome",
    fr: {
      metaTitle: "Chanson pour Remise de Diplôme Personnalisée par IA",
      metaDescription: "Célébrez un diplôme ou une réussite scolaire avec une chanson personnalisée et motivante, créée par IA. Le cadeau original pour féliciter un étudiant ou un jeune diplômé.",
      heroTitle: "Une chanson pour célébrer sa réussite",
      heroSubtitle: "Marquez ce moment de fierté avec une chanson unique qui célèbre les efforts et la réussite d'un étudiant, à offrir lors d'une remise de diplôme ou d'une fête de fin d'études.",
    },
    en: {
      metaTitle: "Personalized AI Graduation Song",
      metaDescription: "Celebrate a graduation or academic achievement with a personalized, motivational song created by AI. The original gift to congratulate a student or new graduate.",
      heroTitle: "A song to celebrate their achievement",
      heroSubtitle: "Mark this proud moment with a unique song that celebrates a student's hard work and success, perfect for a graduation ceremony or end-of-studies party.",
    },
  },
  babyshower: {
    path: "/chanson-baby-shower",
    fr: {
      metaTitle: "Chanson pour Baby Shower Personnalisée par IA | Kalypso Music",
      metaDescription: "Créez une chanson unique pour une baby shower : prénom du bébé à venir, émotion des futurs parents, mélodie douce composée par intelligence artificielle. Une animation originale pour la fête.",
      heroTitle: "La chanson qui célèbre l'arrivée à venir de bébé",
      heroSubtitle: "Surprenez les futurs parents lors de la baby shower avec une chanson 100% personnalisée, pleine de tendresse et d'attente joyeuse. Un souvenir à écouter encore une fois bébé arrivé.",
    },
    en: {
      metaTitle: "Personalized AI Baby Shower Song | Kalypso Music",
      metaDescription: "Create a unique baby shower song: the baby's future name, the parents' emotions, a gentle AI-composed melody. An original highlight for the celebration.",
      heroTitle: "The song that celebrates baby's upcoming arrival",
      heroSubtitle: "Surprise the parents-to-be at the baby shower with a fully personalized song, full of tenderness and joyful anticipation. A keepsake to replay once baby arrives.",
    },
  },
  fete_des_meres: {
    path: "/chanson-fete-des-meres",
    fr: {
      metaTitle: "Chanson pour la Fête des Mères Personnalisée par IA",
      metaDescription: "Offrez à votre maman une chanson unique pour la fête des mères : son prénom, vos souvenirs, un style musical qu'elle adore. Composée par intelligence artificielle en quelques minutes.",
      heroTitle: "Une chanson pour dire merci maman",
      heroSubtitle: "Remplacez les fleurs par une chanson personnalisée qui raconte tout ce que vous ressentez pour elle. Le cadeau de fête des mères le plus émouvant et original.",
    },
    en: {
      metaTitle: "Personalized AI Mother's Day Song",
      metaDescription: "Gift your mom a unique Mother's Day song: her name, your memories, a musical style she loves. Composed by AI in minutes.",
      heroTitle: "A song to say thank you, mom",
      heroSubtitle: "Replace the flowers with a personalized song that tells her everything you feel. The most moving and original Mother's Day gift.",
    },
  },
  fete_des_peres: {
    path: "/chanson-fete-des-peres",
    fr: {
      metaTitle: "Chanson pour la Fête des Pères Personnalisée par IA",
      metaDescription: "Surprenez votre papa avec une chanson personnalisée pour la fête des pères : son prénom, vos souvenirs communs, un style musical à son image, créé par IA en quelques minutes.",
      heroTitle: "Une chanson pour honorer papa",
      heroSubtitle: "Offrez à votre père un cadeau qui sort de l'ordinaire : une chanson unique composée spécialement pour lui, à écouter et réécouter avec émotion.",
    },
    en: {
      metaTitle: "Personalized AI Father's Day Song",
      metaDescription: "Surprise your dad with a personalized Father's Day song: his name, your shared memories, a musical style that suits him, created by AI in minutes.",
      heroTitle: "A song to honor dad",
      heroSubtitle: "Give your father a gift that stands out: a unique song composed especially for him, to listen to again and again with emotion.",
    },
  },
  saint_valentin: {
    path: "/chanson-saint-valentin",
    fr: {
      metaTitle: "Chanson de Saint-Valentin Personnalisée par IA | Kalypso Music",
      metaDescription: "Offrez à votre amoureux ou votre amoureuse une chanson de Saint-Valentin 100% personnalisée : vos prénoms, votre histoire d'amour, votre style musical préféré. Le cadeau romantique le plus original.",
      heroTitle: "La déclaration d'amour la plus originale",
      heroSubtitle: "Remplacez la carte classique par une chanson unique qui raconte votre histoire d'amour, composée par intelligence artificielle spécialement pour la Saint-Valentin.",
    },
    en: {
      metaTitle: "Personalized AI Valentine's Day Song | Kalypso Music",
      metaDescription: "Gift your loved one a fully personalized Valentine's Day song: your names, your love story, your favorite musical style. The most original romantic gift.",
      heroTitle: "The most original love declaration",
      heroSubtitle: "Replace the classic card with a unique song that tells your love story, composed by artificial intelligence especially for Valentine's Day.",
    },
  },
  noel: {
    path: "/chanson-cadeau-noel",
    fr: {
      metaTitle: "Chanson de Noël Personnalisée par IA - Idée Cadeau",
      metaDescription: "Offrez sous le sapin une chanson de Noël personnalisée : prénoms, souvenirs de famille, ambiance festive au choix, composée par intelligence artificielle. L'idée cadeau de Noël la plus originale.",
      heroTitle: "Le cadeau de Noël qu'on n'oublie jamais",
      heroSubtitle: "Surprenez vos proches avec une chanson de Noël unique, écrite et composée spécialement pour eux. Un souvenir musical à réécouter chaque année sous le sapin.",
    },
    en: {
      metaTitle: "Personalized AI Christmas Song - Gift Idea",
      metaDescription: "Put a personalized Christmas song under the tree: names, family memories, festive mood of your choice, composed by AI. The most original Christmas gift idea.",
      heroTitle: "The Christmas gift they'll never forget",
      heroSubtitle: "Surprise your loved ones with a unique Christmas song, written and composed especially for them. A musical keepsake to replay every year by the tree.",
    },
  },
  anniversaire_mariage: {
    path: "/chanson-anniversaire-mariage",
    fr: {
      metaTitle: "Chanson pour Anniversaire de Mariage Personnalisée par IA",
      metaDescription: "Célébrez vos années de mariage avec une chanson unique qui retrace votre histoire d'amour : vos prénoms, vos souvenirs, votre style musical préféré. Créée par IA en quelques minutes.",
      heroTitle: "Une chanson pour célébrer vos années à deux",
      heroSubtitle: "Offrez à votre conjoint(e) une chanson 100% personnalisée pour marquer votre anniversaire de mariage, noces d'or, d'argent ou toute autre étape de votre belle histoire.",
    },
    en: {
      metaTitle: "Personalized AI Wedding Anniversary Song",
      metaDescription: "Celebrate your years of marriage with a unique song retracing your love story: your names, your memories, your favorite musical style. Created by AI in minutes.",
      heroTitle: "A song to celebrate your years together",
      heroSubtitle: "Gift your spouse a fully personalized song to mark your wedding anniversary, golden or silver anniversary, or any milestone of your beautiful story.",
    },
  },
  pot_depart: {
    path: "/chanson-pot-de-depart-collegue",
    fr: {
      metaTitle: "Chanson pour Pot de Départ Collègue Personnalisée par IA",
      metaDescription: "Marquez le départ d'un collègue avec une chanson personnalisée, drôle ou émouvante, qui résume ses années passées dans l'équipe. Créée par IA en quelques minutes, l'idée cadeau collègue originale.",
      heroTitle: "La chanson parfaite pour un pot de départ",
      heroSubtitle: "Célébrez le départ d'un(e) collègue avec une chanson unique et personnalisée, à offrir en cadeau collectif pour marquer ce nouveau chapitre professionnel.",
    },
    en: {
      metaTitle: "Personalized AI Farewell Song for a Coworker",
      metaDescription: "Mark a coworker's departure with a personalized, funny or touching song summing up their time on the team. Created by AI in minutes - the original coworker gift idea.",
      heroTitle: "The perfect song for a farewell party",
      heroSubtitle: "Celebrate a coworker's departure with a unique, personalized song, perfect as a group gift to mark this new professional chapter.",
    },
  },
  remerciement: {
    path: "/chanson-remerciement",
    fr: {
      metaTitle: "Chanson de Remerciement Personnalisée par IA | Kalypso Music",
      metaDescription: "Dites merci autrement avec une chanson personnalisée : pour un(e) ami(e), un mentor, un proche qui vous a soutenu. Paroles et mélodie uniques créées par intelligence artificielle.",
      heroTitle: "Une chanson pour dire merci comme jamais",
      heroSubtitle: "Exprimez votre gratitude d'une façon inoubliable avec une chanson 100% personnalisée dédiée à une personne qui compte pour vous.",
    },
    en: {
      metaTitle: "Personalized AI Thank You Song | Kalypso Music",
      metaDescription: "Say thank you differently with a personalized song: for a friend, a mentor, a loved one who supported you. Unique lyrics and melody created by AI.",
      heroTitle: "A song to say thank you like never before",
      heroSubtitle: "Express your gratitude in an unforgettable way with a fully personalized song dedicated to someone who matters to you.",
    },
  },
  bapteme: {
    path: "/chanson-bapteme",
    fr: {
      metaTitle: "Chanson de Baptême Personnalisée par IA | Kalypso Music",
      metaDescription: "Célébrez le baptême de votre enfant avec une chanson douce et personnalisée : son prénom, la date, un message pour son parrain ou sa marraine. Composée par intelligence artificielle.",
      heroTitle: "Une chanson pour célébrer son baptême",
      heroSubtitle: "Marquez ce moment spécial avec une chanson unique et pleine de douceur, créée pour l'enfant baptisé et à conserver comme souvenir précieux.",
    },
    en: {
      metaTitle: "Personalized AI Christening Song | Kalypso Music",
      metaDescription: "Celebrate your child's christening with a gentle, personalized song: their name, the date, a message from their godparent. Composed by artificial intelligence.",
      heroTitle: "A song to celebrate their christening",
      heroSubtitle: "Mark this special moment with a unique, tender song created for the christened child, to keep as a precious memory.",
    },
  },
  amitie: {
    path: "/chanson-cadeau-amitie",
    fr: {
      metaTitle: "Chanson d'Amitié Personnalisée par IA - Cadeau Meilleure Amie",
      metaDescription: "Offrez à votre meilleur(e) ami(e) une chanson unique qui célèbre votre amitié : vos souvenirs, vos private jokes, votre histoire. Le cadeau le plus original pour une amitié précieuse.",
      heroTitle: "Une chanson pour célébrer votre amitié",
      heroSubtitle: "Dites à votre meilleur(e) ami(e) à quel point il/elle compte pour vous avec une chanson 100% personnalisée, pleine de souvenirs et de complicité.",
    },
    en: {
      metaTitle: "Personalized AI Friendship Song - Best Friend Gift",
      metaDescription: "Gift your best friend a unique song celebrating your friendship: your memories, your inside jokes, your story. The most original gift for a precious friendship.",
      heroTitle: "A song to celebrate your friendship",
      heroSubtitle: "Tell your best friend how much they mean to you with a fully personalized song, full of memories and closeness.",
    },
  },
};
